import mixpanel, { Dict } from "mixpanel-browser";
import { TrackJS } from "trackjs";

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  const numParts = 2;
  if (parts.length === numParts) {
    return parts?.pop()?.split(";").shift();
  }
  return null;
}
const SHOULD_TRACK = getCookie("DoNotTrack") !== "true";

export const initTracking = () => {
  const TRACKJS_ENABLED = import.meta.env.VITE_TRACKJS_ENABLED === "true";
  if (TRACKJS_ENABLED) {
    TrackJS.install({
      token: "76bc2e107fcd4007bdf4b17654b7d041",
      application: "live_quote"
    });
  }

  const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string;
  if (SHOULD_TRACK && MIXPANEL_TOKEN) {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: import.meta.env.MODE === "development",
      track_pageview: "full-url",
      persistence: "localStorage"
    });
  } else if (!MIXPANEL_TOKEN) {
    console.error("Mixpanel failed to initialize (token missing)");
  }

  // Track all link and button clicks
  const appContainer = document.querySelector("#root");
  appContainer?.addEventListener("click", e => {
    const element = e.target as HTMLElement;

    if (!element) {
      return;
    }

    if (element.tagName === "BUTTON") {
      const id = element.dataset.testid ?? element.innerText;
      mixpanelTrack("user_click", { id, element: "button" });
    }

    if (element.tagName === "A") {
      const href = element.getAttribute("href");
      if (!href) {
        return;
      }
      const url = new URL(href, window.location.origin);
      if (url.host !== window.location.host) {
        mixpanelTrack("external_link", { url: href });
      } else {
        const id = element.dataset.testid ?? element.innerText;
        mixpanelTrack("user_click", { id, element: "anchor" });
      }
    }
  });

  // Track page reloads
  window.addEventListener("load", () => {
    const isReload =
      window.performance
        .getEntriesByType("navigation")
        .filter(entry => entry.entryType === "reload").length > 0;
    if (isReload) {
      mixpanelTrack("page_reload");
    }
  });
};

export const mixpanelTrack = (name: string, props?: Dict) => {
  try {
    mixpanel.track(name, props);
  } catch (_e) {
    //ignore errors
  }
};
